var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-2user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.25165 8.60543C7.17249 8.59751 7.07749 8.59751 6.9904 8.60543C5.10624 8.54209 3.60999 6.99834 3.60999 5.09834C3.60999 3.15876 5.17749 1.58334 7.12499 1.58334C9.06457 1.58334 10.64 3.15876 10.64 5.09834C10.6321 6.99834 9.13582 8.54209 7.25165 8.60543Z",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9912 3.16666C14.5271 3.16666 15.7621 4.40957 15.7621 5.93749C15.7621 7.43374 14.5746 8.65291 13.0941 8.70832C13.0308 8.70041 12.9596 8.70041 12.8883 8.70832",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.29332 11.5267C1.37749 12.8092 1.37749 14.8992 3.29332 16.1737C5.4704 17.6304 9.04082 17.6304 11.2179 16.1737C13.1337 14.8912 13.1337 12.8012 11.2179 11.5267C9.04874 10.0779 5.47832 10.0779 3.29332 11.5267Z",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.5192 15.8333C15.0892 15.7146 15.6275 15.485 16.0708 15.1446C17.3058 14.2183 17.3058 12.6904 16.0708 11.7642C15.6354 11.4317 15.105 11.21 14.5429 11.0833",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.be599d2cc1eafe50bd3190e046cf4d06.svg";
export { ForwardRef as ReactComponent };